import React, { forwardRef } from 'react'
import styled from 'react-emotion'
import { color } from '../../../../style'
import { RowButton } from 'common/components/Row'

const SidebarRow = styled(
  forwardRef(({ dropLocation, ...props }, ref) => {
    return <RowButton {...props} ref={ref} />
  })
)(({ selected, grey, dropLocation }) => {
  const style = {
    label: 'SidebarRow',
    background: grey && color.greyBlock
  }

  if (!selected) {
    // unless this row is selected, hovered or menu is showing: hide ••• button
    style[`&:not(:hover) .button`] = {
      display: 'none'
    }
  }

  if (dropLocation) {
    // dropping somewhere, no hovers
    style['&:hover'] = { backgroundColor: 'initial' }

    // dropping in this folder
    if (dropLocation === 'inside') {
      style.backgroundColor = color.hover
      style['&:hover'] = { backgroundColor: color.hover }
    }
    // not allowed to drop in this folder
    if (dropLocation === 'notAllowed') {
      style.cursor = 'not-allowed'
    }

    if (dropLocation === 'before' || dropLocation === 'after') {
      style.position = 'relative'
      style[':before'] = {
        position: 'absolute',
        content: "''",
        left: 0,
        right: 0,
        height: 1,
        background: '#999'
      }
      if (dropLocation === 'before') style[':before'].top = 0
      if (dropLocation === 'after') style[':before'].bottom = -1
    }
  }

  return style
})

export default SidebarRow
